const appConfig = {
  "name": "mitid-v2-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "6nmjqgejigjj22gj9mil0ov181",
    "redirectUris": [
      "https://mitid-dev.mit.edu",
      "https://mitid.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://mitid-dev.mit.edu/logout",
      "https://mitid.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "email",
      "mit:user:all.manage",
      "mit:user:all.read",
      "mit:user:mitid.manage",
      "offline_access",
      "openid",
      "phone",
      "profile"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "6nmjqgejigjj22gj9mil0ov181",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "address",
        "email",
        "offline_access",
        "openid",
        "phone",
        "profile"
      ],
      "redirectUris": [
        "https://mitid-dev.mit.edu",
        "https://mitid.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://mitid-dev.mit.edu/logout",
        "https://mitid.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;